export enum FreshServicePriorityEnum {
    Low = 1,
    Medium,
    High,
    Urgent,
}
